module.exports = __webpack_public_path__ + "Group 15704.9d5ff5b75046b9daaba7.png";